// enums
import React, { JSX } from 'react';

import { Dayjs } from 'dayjs';

export enum IFieldType {
  SWING_CONTRACT = 'SwingContract',
  FIELD_MAPPING = 'field-mapping',
}

export enum ModalType {
  NONE = 'NONE',
  CLONE = 'CLONE',
  AUDIT = 'AUDIT',
  UPLOAD_TO_ALIGNE = 'UPLOAD_TO_ALIGNE',
  UPLOAD_TO_ENDUR = 'UPLOAD_TO_ENDUR',
}

export enum SwingContractOperationMode {
  EDIT = 'edit',
  CLONE = 'clone',
}

export enum SwingContractAligneStatusIndex {
  NEW = 0,
  SUBMITTED = 1,
  SUCCESS = 2,
  FAILURE = 3,
  ACKNOWLEDGED = 4,
  INQUEUE = 6,
}

export enum SwingContractAligneStatus {
  NEW = 'New',
  SUBMITTED = 'Submitted',
  SUCCESS = 'Success',
  FAILURE = 'Failure',
}

// interfaces

export interface SwingContractData {
  id: number;
  contractId: number;
  contractName: string;
  gasDay: string;
  mappingId: number;
  description: string;
  emailTimeStamp: string;
  emailEnergyInMwh: number | null;
  manualEnergy: number | null;
  persistedEnergy: number | null;
  endurEnergy: number | null;
  currentAligne: number | null;
  rawEnergy: string;
  rawGasDay: string;
  isMatched: number;
  isSentToAligne: number;
  source: string;
  destination: string;
  zKey: string;
  deal_DealLegId?: string;
  endurUploadStatus?: string;
  aligneUploadStatus?: string;
  entryOrExitId: number;
  entryOrExit: string;
  total: number | null;
  note: string | null;
  unit: string;
  isLatest: boolean;
  transactionId?: string;
}

export type ISwingContractNominations = {
  entryData: SwingContractData[];
  exitData: SwingContractData[];
  totalEntryRecords: number;
  totalExitRecords: number;
};

export interface SwingContractTableProps {
  data: SwingContractData[];
  totalRecords: number;
  loading: boolean;
  checkedItems: number[];
  renderAuditInfo: (item: SwingContractData) => JSX.Element;
  renderEditCloneActions: (
    item: SwingContractData,
    type: 'edit' | 'clone',
    disableActions: boolean
  ) => JSX.Element;
  tableFilters: {
    actionable: string;
    latest: string;
    energy: string;
    fromDate: string;
  };
  setCheckedItems: React.Dispatch<React.SetStateAction<number[]>>;
  activeTab: string;
}

export interface SwingContractResponse {
  entryData: SwingContractData[];
  exitData: SwingContractData[];
  refreshedInfo?: {
    refreshedTime: string;
  };
}

export interface SwingContractMapping {
  id: number;
  contractNameId: number;
  contractName?: string;
  entryOrExitId?: number;
  description: string;
  entryOrExit: string;
  zKey: number;
  deal_DealLegId?: string;
  dealUnit: 'Therms';
  unit: string;
  locationOrExitMeter: string;
  geminiActivityNumber: string;
  validFrom: string;
  validTo: string;
  source: string;
  destination?: string;
  notes?: string;
  isActive: boolean;
  createdDateTimeStamp: string;
  updatedDateTimeStamp: string;
}

interface ISETAPayload {
  id: number;
  payloadType: string;
}

export interface IFieldAuditLogs {
  id: number;
  note: string;
  expanded: boolean;
  setaPayload: Record<string, unknown> | null;
  createdDateTimeinGMT: string;
  setaPayloadLoading?: boolean;
  payload?: ISETAPayload | null;
}

export interface ILogsState {
  hasLoading: boolean;
  auditLogs: Array<IFieldAuditLogs>;
}

export interface GetFieldAuditLogsParams {
  url: string;
  hasLogs: boolean;
  fieldType: IFieldType;
  origin?: string;
}

export type IUploadToAligne = SwingContractData & {
  index: number;
  updatedEnergy?: number | null;
  comment: string;
  origin: string;
};

export interface IUploadToAlignePayload {
  id: number;
  gasDay: string;
  energy: number;
  zkey: number;
  comment: string;
  contractName: string;
}

export interface IUploadToEndurSwingContract {
  open: boolean;
  onClose: () => void;
  refreshData: () => void;
  selectedUnit: string;
  data: SwingContractData[];
  renderEnergy: (energy: number | null) => React.ReactNode;
}

export interface IUploadToEndurSwingContractItems {
  id: number;
  contractName: string;
  gasDay: string;
  emailTimeStamp: string;
  dealDealLegId?: string;
  transactionId?: string;
  energyInKWh: number | null;
}

export type SwingContractStatusObject = {
  title: string;
  className: string;
};

export type FilterAlignStatusReturnType = {
  id: number;
  name: SwingContractAligneStatus;
  isActive: boolean;
};

// get current Aligne

export interface IGetCurrentAligneComponent {
  dateType: string;
  fromDate: string;
  toDate: string;
  refreshData: () => void;
}

export type IUpdateCloneSwingContract = {
  open: boolean;
  onClose: () => void;
  selectedItem: SwingContractData | null;
  refreshData: () => void;
  currentEnergyUnit?: string;
  isEditMode?: boolean;
};

export type EnergyType = 'Therms' | 'TJ' | 'GWh' | 'KWh';
export type FilterType = 'DR' | 'WD' | 'DA';

export interface SwingContractFilterValues {
  filterType: FilterType;
  fromDate: string;
  toDate: string;
  energy: EnergyType;
  actionable: string;
  latest: string;
}

export type SwingContractFormData = Pick<
  SwingContractData,
  'id' | 'contractName' | 'source' | 'note'
> & {
  manualEnergy: number | null;
  gasDayRange?: [Dayjs | null, Dayjs | null];
  gasDay?: Dayjs;
  swingContractMappingId: number;
  unit: string;
};

export type SwingContractPayload = Pick<SwingContractData, 'id'> & {
  manualEnergy: number | null;
  unit?: string;
  note: string;
  fromGasDay?: string;
  toGasDay?: string;
  swingContractMappingId?: number;
};

export interface RenderValueProps {
  displayValue: string | React.ReactNode;
}

export interface StatusIconCellProps {
  validFrom: string;
  validTo: string;
}

export interface DateCellProps {
  date: string;
}
